import api from "services/api";
import {
  IGetAllPermissionByCustomerIdAndProfileId,
  routers_constants,
} from "services/constants";

export const permissionServices = {
  getAllPermissionByCustomerIdAndProfileId: async ({
    customerId,
    profileId,
  }: IGetAllPermissionByCustomerIdAndProfileId) => {
    try {
      const url =
        routers_constants.permissions.getAllPermissionByCustomerIdAndProfileId({
          customerId,
          profileId,
        });
      const { data } = await api.get(url);

      return {
        data: data.data,
        success: true,
      };
    } catch (error: any) {
      return {
        data: error?.response?.data,
        success: false,
      };
    }
  },
};
